module.exports = __webpack_public_path__ + "static/media/fb.37192a61.svg";